import { useRouteError, useNavigate } from 'react-router';
import { ApiError } from '@/lib/errors';

export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  const message =
    error instanceof ApiError
      ? error.userMessage
      : 'Something went wrong loading this page.';

  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 px-6 py-16 text-center">
      <h1 className="text-xl font-semibold text-content">This page did not load</h1>
      <p className="text-content-secondary">{message}</p>
      <button
        type="button"
        onClick={() => navigate('/home', { replace: true })}
        className="rounded-md bg-primary px-4 py-2 font-medium text-white hover:bg-primary-shade focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
      >
        Back to funds
      </button>
    </div>
  );
}
